var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.107 5.45887L9.46272 0.595733C8.65639 -0.193059 7.34361 -0.193059 6.5706 0.563138L0.859642 5.49146C0.306539 6.03253 0 6.75614 0 7.52537V14.0378C0 15.1199 0.899625 16 2.00583 16H14.0008C15.1004 16 16 15.1199 16 14.0378V7.52537C16 6.75614 15.6935 6.03253 15.107 5.45887ZM14.6672 14.0378C14.6672 14.4029 14.3673 14.6962 14.0008 14.6962H9.77593V10.498C9.77593 10.1199 9.46939 9.82004 9.08288 9.82004H6.91712C6.53728 9.82004 6.22407 10.1199 6.22407 10.498V14.6962H2.00583C1.63265 14.6962 1.33278 14.4029 1.33278 14.0378V7.52537C1.33278 7.11468 1.50604 6.70398 1.77259 6.43671L7.48355 1.5149C7.62349 1.37801 7.80341 1.3063 7.99 1.3063C8.18992 1.3063 8.38984 1.38453 8.54977 1.54098L14.1941 6.41063C14.5006 6.7105 14.6672 7.10816 14.6672 7.52537V14.0378Z",
    fill: "#14142B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHover);
export default __webpack_public_path__ + "static/media/home-hover.a3449341354d27ee1c65d4a7d58d80a5.svg";
export { ForwardRef as ReactComponent };